import React from 'react';
import { apiRequestHandler } from '../apiConfig/service';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Jobs() {
    const [job,setJob] = useState();
    const [isLoading,setIsLoading] = useState();
    const navigate = useNavigate();
    const [search,setSearch] = useState();

    const getServices = async (endPoint, token) => {
      const res = await apiRequestHandler({ endPoint, headers: { Authorization: `Bearer ${token}` },params:{search}});
      return res;
    };

    useEffect(() => {
        const fetchServices = async () => {
          setIsLoading(true); // Start loading
          try {
            const res = await getServices('allJob', localStorage.getItem('token'));
            setJob(res.job || []);
            console.log('res: ',res)
          } catch (error) {
            console.error('Error fetching services:', error);
            toast.error('Failed to load services');
            setJob([]);
          } finally {
            setIsLoading(false); // End loading
          }
        };
        fetchServices();
      }, []);

        const fetchSearchJob = async () => {
          setIsLoading(true); // Start loading
          try {
            const res = await getServices("searchJob", localStorage.getItem('token'));
            setJob(res.job || []);
            console.log('res: ',res)
          } catch (error) {
            console.error('Error fetching services:', error);
            toast.error('Failed to load services');
            setJob([]);
          } finally {
            setIsLoading(false); // End loading
          }
        };




    return (
        <div className='container default-padding'>
            <div className="row justify-content-center">
                <div className="col-md-10">
                    <div className='mb-4'>
                        <h2>Browse Jobs</h2>
                        <p>
                            Select a function and the country where you're eligible to work to see remote-eligible roles in your area.
                            We can hire people in any country where we have a legal entity, assuming you have eligible working rights
                            and a sufficient timezone overlap with your team. All Atlassians can choose to work remotely or return to an office
                            (unless it's necessary for the role to be performed in the office).
                        </p>
                    </div>

                    <div className='d-flex justify-content-between mb-4'>
                        <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0 shadow-none"
                            placeholder="Search"
                            style={{ backgroundColor: 'transparent' }}
                            onChange={(e)=>setSearch(e.target.value)}
                        />
                        <button onClick={fetchSearchJob} className='job-btn btn-primary mt-2 mt-md-0'>
                          <i class="fa-solid fa-magnifying-glass"></i>
                          </button>
                    </div>
                </div>
            </div>

            <div className='row justify-content-center g-3'>
              {job && job.length > 0 ? 
              job.map((job, index) => (
                    <div className='col-10' key={index}>
                        <div onClick={()=> navigate('/job/details',{ state: { job } })}
                        style={{cursor:'pointer'}} className="card shadow-sm border-0">
                            <div className="card-body d-flex justify-content-between align-items-center flex-wrap">
                                <div>
                                <h5 className="card-title mb-0">{job?.jobTitle || ''}</h5>
                                <p className="mb-0 text-muted small">Vacancy: {job?.noOfVacancies || ''}</p>
                                <p className="mb-0 text-muted small">Experience: {job?.minExp +"-"+job?.maxExp + " Years" || ''}</p>
                                </div>
                                <button 
                                 className="job-btn btn-primary mt-2 mt-md-0"
                                 >Apply
                                </button>
                            </div>
                        </div>
                    </div>
                )) 
              :<><div className='col-10'>
                        <div className="card shadow-sm border-0 mt-5">
                            <div className="card-body d-flex justify-content-center align-items-center flex-wrap">
                                <div>
                                <h5 className="card-title pb-2">No Jobs Are There...</h5>
                                </div>
                            </div>
                        </div>
                    </div></>}
            </div>
        </div>
    );
}

export default Jobs;
